


























import { Component } from 'vue-property-decorator'
import VueBase from '@/VueBase'

@Component({ name: 'SettingIndex' })
export default class SettingIndex extends VueBase {
  hiddenMap = {
    sensitive: true,
    strategy: true,
    template: true,
    agentConfig: true,
    webhook: true,
  }
  private curModule(path: string) {
    return this.$route.name === path
  }
  get Routers() {
    const R = this.$store.getters.routers[0].children.filter((i: any) => {
      return i.name === 'setting'
    })[0]
    if (R) {
      return R.children
    } else {
      return []
    }
  }
  created() {
    console.log()
  }
  get userInfo(): { username: string } {
    return this.$store.getters.userInfo
  }
}
